export default __webpack_public_path__ + "media/086f923c394df874a8b27e07542873448e216100b5ccd15010b1de694f73414f.svg";